import esg_event_bar_chart from '../components/ESGEventBarChart'
import esg_event_count_list from '../components/ESGEventCountList'
let esg_home = {
  components: {esg_event_bar_chart, esg_event_count_list},
}
export default esg_home



// WEBPACK FOOTER //
// ./src/esg/js/esg_home.js